import { applyFicheDueDay, DEFAULT_FICHE_DUE_TIME, snapToQuarter } from '../tasks/taskDueTime';

export interface AppointmentDraft {
  title: string;
  startDay: string;
  startTime: string;
  endDay: string;
  endTime: string;
  participantIds: string[];
  dossierId: string | null;
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function ficheToInstant(day: string, time: string): string | null {
  if (!day) return null;
  return applyFicheDueDay(day, time).due_datetime;
}

export function instantToFiche(iso: string): { day: string; time: string } {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { day: '', time: DEFAULT_FICHE_DUE_TIME };
  return {
    day: `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`,
    time: snapToQuarter(`${pad2(d.getHours())}:${pad2(d.getMinutes())}`),
  };
}

/** Décale une date+heure de fiche de `minutes` (local). 23:30 + 60 → lendemain 00:30. */
export function shiftQuarterHour(
  day: string,
  time: string,
  minutes: number,
): { day: string; time: string } {
  const iso = ficheToInstant(day, time);
  if (!iso) return { day, time: snapToQuarter(time || DEFAULT_FICHE_DUE_TIME) };
  const d = new Date(iso);
  d.setMinutes(d.getMinutes() + minutes);
  return instantToFiche(d.toISOString());
}

export function appointmentRangeError(draft: Pick<
  AppointmentDraft,
  'startDay' | 'startTime' | 'endDay' | 'endTime'
>): string | null {
  const start = ficheToInstant(draft.startDay, draft.startTime);
  const end = ficheToInstant(draft.endDay, draft.endTime);
  if (!start || !end) return null;
  if (new Date(end).getTime() <= new Date(start).getTime()) {
    return 'La fin doit être après le début.';
  }
  return null;
}

export function canSubmitAppointment(draft: AppointmentDraft): boolean {
  if (!draft.title.trim()) return false;
  if (draft.participantIds.length < 1) return false;
  if (!draft.startDay || !draft.endDay) return false;
  const start = ficheToInstant(draft.startDay, draft.startTime);
  const end = ficheToInstant(draft.endDay, draft.endTime);
  if (!start || !end) return false;
  return new Date(end).getTime() > new Date(start).getTime();
}
